/**
 * レイアウト共通処理
 */

import * as constants from "@/mixin/constants";
import common from "@/mixin/common";

var platform = require("platform");

/**
 * SP版特殊レイアウト設定index配列
 */
// layout122
export const SORT_LAYOUT_122 = [0, 1, 4, 2, 3, 5];
// layout307
export const SORT_LAYOUT_307 = [0, 1, 3, 4, 2];
// layout327
export const SORT_LAYOUT_327 = [0, 1, 5, 2, 3, 4, 6, 7];

export default {
  data() {
    return {};
  },
  mixins: [common],
  methods: {
    /**
     * レイアウト判定用のオブジェクトを取得する
     */
    getLayoutObject: function(layoutID) {
      this.log("commonLayout start getLayoutObject");
      
      if(this.pathstep.modeGroup === constants.MODE_GROUP_ACT_CHOICE) {
        if(!this.isEnvironmentPc()) {
          switch (layoutID) {
            /**
             * A1系レイアウト
             */
             
            // 4枚レイアウト
            case 2:
              return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4s"]] };
            case 6:
            case 105:
            case 106:
              return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
            
            // 5枚レイアウト
            case 3:
              return { actNums: [[5]], containerClass: "", innerClasses: [["card-col5s"]] };
            case 110:
              return { actNums: [[5]], containerClass: "", innerClasses: [["card-col5p"]] };
            
            // 6枚レイアウト
            case 4:
            case 113:
              return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6s"]] };
            case 5:
            case 32:
            case 115:
            case 116:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
              return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6p"]] };
              
            // 7枚レイアウト
            case 123:
              return { actNums: [[7]], containerClass: "", innerClasses: [["card-col7s"]] };
            case 125:
              return { actNums: [[7]], containerClass: "", innerClasses: [["card-col7p"]] };
            
            // 8枚レイアウト
            case 127:
              return { actNums: [[8]], containerClass: "", innerClasses: [["card-col8s"]] };
            case 129:
              return { actNums: [[8]], containerClass: "", innerClasses: [["card-col8p"]] };
              
            // 10枚レイアウト
            case 130:
              return { actNums: [[10]], containerClass: "", innerClasses: [["card-col10s"]] };
            
            /**
             * A3系レイアウト
             */
             
            // 4枚レイアウト
            case 24:
              return { actNums: [[4]], containerClass: "a3-card4", innerClasses: [["card-col4p"]] };  
              
            default:
              break;
          }
        }
      }

      switch (layoutID) {
        /**
         * A系レイアウト
         */

        // 2*1レイアウト
        case 101:
          return { actNums: [[2]], containerClass: "", innerClasses: [["card-col2s"]] };

        // 3*1レイアウト
        case 1:
        case 20:
        case 55:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3s"]] };
        case 102:
          return { actNums: [[2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"]] };
        case 178:
          return { actNums: [[1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"]] };
        case 103:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3p"]] };

        // 4*1レイアウト
        case 104:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4s"]] };
        case 180:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
        case 191:
          return { actNums: [[1, 2, 1]], containerClass: "", innerClasses: [["card-col1s", "card-col2p", "card-col1s"]] };
        case 28:
        case 36:
          return { actNums: [[2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"]] };
        case 196:
          return { actNums: [[1, 3]], containerClass: "", innerClasses: [["card-col1s", "card-col3p"]] };
        case 700:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4s"]] };
          }
          return { actNums: [[2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2s"]] };

        // 2*2レイアウト
        case 2:
        case 21:
        case 31:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2s"]] };
        case 9:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2p"]] };
          }
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
        case 106:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2s"]] };
        case 105:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p"]] };
        case 6:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p full"]] };

        // pronunciation-1,3レイアウト
        case 702:
          return { actNums: [[1], [3]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3p"]] };

        // 1,2*2レイアウト
        case 132:
        case 107:
        case 181:
          return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
        case 108:
          if (this.isEnvironmentPc()) {
            return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 133:
          if (this.isEnvironmentPc()) {
            return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[1], [4]], containerClass: "", innerClasses: [["card-col1s"], ["card-col4p"]] };

        // 3,2レイアウト
        case 3:
        case 34:
        case 38:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2s"]] };
        case 111:
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 110:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
        case 109:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p"]] };
        case 112:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 1], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2s"]] };
        case 168:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 1], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2p"]] };
        case 167:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
          }
          return { actNums: [[1, 2], [2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2s"]] };
        case 169:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };
          }
          return { actNums: [[1, 2], [2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2p"]] };
        case 29:
        case 37:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };

        // 2,3レイアウト
        case 176:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3s"]] };
        case 134:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3s"]] };
        case 170:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3p"]] };
          }
          return { actNums: [[2], [2, 1]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p", "card-col1s"]] };
        case 182:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3p"]] };
          }
          return { actNums: [[2], [1, 2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col1s", "card-col2p"]] };
        case 135:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3p"]] };
          }
          return { actNums: [[2], [2, 1]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p", "card-col1s"]] };
        case 171:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3p"]] };
          }
          return { actNums: [[2], [1, 2]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col1s", "card-col2p"]] };
        case 172:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col3p"]] };
        case 186:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
        case 193:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
          }
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col5p"]] };

        // 3*3レイアウト
        case 4:
        case 33:
        case 35:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3s"]] };
        case 8:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6p"]] };
        case 116:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 1], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col3s"]] };
        case 179:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
          }
          return { actNums: [[1, 2], [3]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col3s"]] };
        case 117:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
          }
          return { actNums: [[3], [2, 1]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p", "card-col1s"]] };
        case 115:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
          }
          return { actNums: [[3], [1, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col1s", "card-col2p"]] };
        case 136:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
        case 137:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
        case 118:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 1], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2p", "card-col1s"]] };
        case 120:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 1], [1, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col1s", "card-col2p"]] };
        case 187:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [2, 1]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2p", "card-col1s"]] };
        case 119:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col1s", "card-col2p"]] };
        case 32:
        case 56:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
        case 138:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [3]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col3p"]] };
        case 30:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[3], [2, 1]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p", "card-col1s"]] };

        // 4,2レイアウト
        case 113:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2s"]] };
        case 114:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
          }
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6p"]] };
        case 139:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2s"]] };
        case 173:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2s"]] };
        case 174:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p"]] };
        case 121:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2s"]] };
        case 175:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p"]] };
        case 140:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p"]] };
        case 122:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2s"]] };
          }
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
        case 5:
        case 7:
        case 51:
        case 57:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p"]] };
        case 195:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };

        // 2,4レイアウト
        case 141:
          return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2s"], ["card-col4s"]] };
        case 183:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2s"], ["card-col4p"]] };
          }
          return { actNums: [[2], [2, 2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p", "card-col2p"]] };
        case 184:
          return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2p"], ["card-col4p"]] };
        case 185:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2p"], ["card-col4p"]] };
          }
          return { actNums: [[2], [2, 2]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p", "card-col2p"]] };
        case 194:
          return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2p"], ["card-col4s"]] };

        // 4,3レイアウト
        case 123:
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3s"]] };
        case 124:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[7]], containerClass: "", innerClasses: [["card-col7p"]] };
        case 142:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col3s"]] };
        case 143:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
          }
          return { actNums: [[4], [2, 1]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p", "card-col1s"]] };
        case 144:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
          }
          return { actNums: [[4], [1, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col1s", "card-col2p"]] };
        case 145:
          
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
        case 125:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col3s"]] };
        case 146:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col1s"]] };
        case 189:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 3], [3]], containerClass: "", innerClasses: [["card-col1s", "card-col3p"], ["card-col3p"]] };
        case 147:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col1s"]] };
        case 190:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col3p"]] };

        // 3,4レイアウト
        case 148:
          return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3s"], ["card-col4s"]] };
        case 149:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 1], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col4s"]] };
        case 177:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3s"], ["card-col4p"]] };
          }
          return { actNums: [[3], [2, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p", "card-col2s"]] };
        case 150:
          return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3p"], ["card-col4s"]] };
        case 126:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3p"], ["card-col4p"]] };
          }
          return { actNums: [[1, 2], [2, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2p", "card-col2p"]] };

        // 4,4レイアウト
        case 127:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4s"]] };
        case 128:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[8]], containerClass: "", innerClasses: [["card-col8p"]] };
        case 151:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col4s"]] };
        case 152:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p", "card-col2s"]] };
        case 153:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2s", "card-col2p"]] };
        case 154:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
        case 155:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col4s"]] };
        case 156:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col2s"]] };
        case 157:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2s", "card-col2p"]] };
        case 158:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2s", "card-col2p"]] };
        case 159:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p", "card-col2p"]] };
        case 160:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [3, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col3p", "card-col1s"]] };
        case 161:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[3, 1], [2, 2]], containerClass: "", innerClasses: [["card-col3p", "card-col1s"], ["card-col2p", "card-col2s"]] };
        case 162:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2s"]] };
        case 163:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col2p"]] };
        case 164:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p", "card-col2p"]] };
        case 165:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p", "card-col2p"]] };
        case 166:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col4p"]] };
        case 129:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2p"]] };
        case 197:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
        case 198:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[1, 3], [4]], containerClass: "", innerClasses: [["card-col1s", "card-col3p"], ["card-col4p"]] };
        case 701:
          return { actNums: [[4, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };

        // 3*3*3レイアウト
        case 188:
          return { actNums: [[3, 3], [3]], containerClass: "", innerClasses: [["card-col3p", "card-col3p"], ["card-col3p"]] };

        // 5*2レイアウト
        case 130:
          if (this.isEnvironmentPc()) {
            return { actNums: [[10]], containerClass: "", innerClasses: [["card-col10s"]] };
          }
          return { actNums: [[5, 5]], containerClass: "", innerClasses: [["card-col5s", "card-col5s"]] };
        case 199:
          return { actNums: [[1, 2, 2], [1, 2, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p", "card-col2p"], ["card-col1s", "card-col2p", "card-col2p"]] };

        // 6*2レイアウト
        case 131:
          if (this.isEnvironmentPc()) {
            return { actNums: [[6], [6]], containerClass: "", innerClasses: [["card-col6p"], ["card-col6p"]] };
          }
          return { actNums: [[12]], containerClass: "", innerClasses: [["card-col12p"]] };
        case 192:
          return { actNums: [[2, 2, 2], [2, 2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p", "card-col2p"], ["card-col2p", "card-col2p", "card-col2p"]] };

        /**
         * A3系レイアウト
         */

        // 2枚レイアウト
        case 202:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2]], containerClass: "a3-card2", innerClasses: [[""]] };
          }
          return { actNums: [[2]], containerClass: "a3-card2", innerClasses: [["card-col2s"]] };

        // 3枚レイアウト
        case 66:
          return { actNums: [[3]], containerClass: "a3-card3", innerClasses: [[""]] };
        case 201:
          return { actNums: [[3]], containerClass: "a3-card3", innerClasses: [[""]] };

        // 4枚レイアウト
        case 27:
          return { actNums: [[4]], containerClass: "a3-card4", innerClasses: [[""]] };
        case 24:
          return { actNums: [[2, 2]], containerClass: "a3-card-g2", innerClasses: [["card-col2p", "card-col2p"]] };
        case 203:
          return { actNums: [[2, 2]], containerClass: "a3-card-g2", innerClasses: [["card-col2p", "card-col2s"]] };

        // 5枚レイアウト
        case 67:
          return { actNums: [[5]], containerClass: "a3-card5", innerClasses: [[""]] };

        // 6枚レイアウト
        case 68:
          return { actNums: [[6]], containerClass: "a3-card6", innerClasses: [[""]] };
        case 26:
          return { actNums: [[2, 2, 2]], containerClass: "a3-card-g2", innerClasses: [["card-col2p", "card-col2p", "card-col2p"]] };
        case 25:
          return { actNums: [[3, 3]], containerClass: "a3-card-g2", innerClasses: [["card-col3p", "card-col3p"]] };
        case 23:
          return { actNums: [[6]], containerClass: "a3-card-g6", innerClasses: [[""]] };

        /**
         * A3Qレイアウト
         */
        case 601:
          return { actNums: [[3]], containerClass: "a3-card3", innerClasses: [[""]] };
        case 602:
          return { actNums: [[4]], containerClass: "a3-card4", innerClasses: [[""]] };
        case 605:
          return { actNums: [[6]], containerClass: "a3-card6", innerClasses: [[""]] };

        /**
         * ThreeTwoOneレイアウト
         */
        case 604:
          return { actNums: [[3, 2, 1]], containerClass: "a3-card6", innerClasses: [["card-col3p", "card-col2p", "card-col1s"]] };

        /**
         * TwoTwoレイアウト
         */
        case 603:
          return { actNums: [[2, 2]], containerClass: "a3-card-g2", innerClasses: [["card-col2p", "card-col2p"]] };

        /**
         * P系レイアウト
         */

        // 1*1レイアウト
        case 401:
          return { actNums: [[1]], containerClass: "", innerClasses: [["card-col1s"]] };

        // 2*1レイアウト
        case 402:
          return { actNums: [[2]], containerClass: "", innerClasses: [["card-col2s"]] };

        // 3*1レイアウト
        case 58:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3s"]] };
        case 64:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3p"]] };
        case 421:
          return { actNums: [[2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"]] };
        case 433:
          return { actNums: [[1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"]] };

        // 4*1レイアウト
        case 403:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4s"]] };
        case 434:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
        case 450:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
          }
          return { actNums: [[1], [3]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3p"]] };

        // 2*2レイアウト
        case 12:
        case 39:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2s"]] };
        case 14:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col2p2r"]] };
        case 422:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2s"]] };
        case 424:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p"]] };
        case 13:
        case 40:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p full"]] };

        // pronunciation-2 syllablesレイアウト
        case 417:
        case 449:
        case 440:
          return { actNums: [[1], [3]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3p"]] };
        case 448:
          return { actNums: [[1], [3]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3s"]] };

        // 1,2*2レイアウト
        case 404:
        case 405:
        case 406:
        case 407:
          return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
        case 438:
          if (this.isEnvironmentPc()) {
            return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[1], [3, 1]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3p", "card-col1s"]] };

        // 3,2レイアウト
        case 41:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2s"]] };
        case 70:
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 42:
        case 45:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };
        case 439:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3s"]] };
        case 444:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 1], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2s"]] };

        // 2,3レイアウト
        case 423:
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 426:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
          }
          return { actNums: [[2], [2, 1]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p", "card-col1s"]] };
        case 427:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
        case 428:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };

        // pronunciation-3 syllablesレイアウト
        case 418:
          return { actNums: [[1], [4]], containerClass: "", innerClasses: [["card-col1s"], ["card-col4p"]] };
        case 441:
          return { actNums: [[1], [4]], containerClass: "", innerClasses: [["card-col1s"], ["card-col4p"]] };

        // 3*3レイアウト
        case 44:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3s"]] };
        case 54:
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 43:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
        case 429:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col1s", "card-col2p"]] };
        case 431:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[3], [2, 1]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p", "card-col1s"]] };
        case 445:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 1], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col3s"]] };
        case 446:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 5]], containerClass: "", innerClasses: [["card-col1s", "card-col5p"]] };

        // 4,2レイアウト
        case 408:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2s"]] };
        case 409:
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6p"]] };
        case 425:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
        case 52:
        case 53:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p"]] };

        // 2,4レイアウト
        case 432:
          return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2s"], ["card-col4s"]] };

        // pronunciation-4 syllablesレイアウト
        case 419:
          return { actNums: [[1], [5]], containerClass: "", innerClasses: [["card-col1s"], ["card-col5p"]] };
        case 442:
          return { actNums: [[1], [5]], containerClass: "", innerClasses: [["card-col1s"], ["card-col5p"]] };

        // 4,3レイアウト
        case 410:
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3s"]] };
        case 411:
          return { actNums: [[7]], containerClass: "", innerClasses: [["card-col7p"]] };

        // pronunciation-5 syllablesレイアウト
        case 420:
          return { actNums: [[1], [6]], containerClass: "", innerClasses: [["card-col1s"], ["card-col6p"]] };
        case 443:
          return { actNums: [[1], [6]], containerClass: "", innerClasses: [["card-col1s"], ["card-col6p"]] };

        // 4*2レイアウト
        case 412:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4s"]] };
        case 413:
          return { actNums: [[8]], containerClass: "", innerClasses: [["card-col8p"]] };
        case 414:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
        case 415:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2p"]] };
        case 437:
          return { actNums: [[4, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
        case 447:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2p"]] };

        // pronunciation-6 syllablesレイアウト
        case 430:
          return { actNums: [[1], [7]], containerClass: "", innerClasses: [["card-col1s"], ["card-col7s"]] };

        // 5*2レイアウト
        case 435:
          if (this.isEnvironmentPc()) {
            return { actNums: [[5], [5]], containerClass: "", innerClasses: [["card-col5p"], ["card-col5p"]] };
          }
          return { actNums: [[1, 2, 2], [1, 2, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p", "card-col2p"], ["card-col1s", "card-col2p", "card-col2p"]] };

        // 6*2レイアウト
        case 416:
          return { actNums: [[12]], containerClass: "", innerClasses: [["card-col12p"]] };
        case 436:
          return { actNums: [[6], [6]], containerClass: "", innerClasses: [["card-col6s"], ["card-col6s"]] };

        /**
         * Tile系レイアウト
         */

        // 2*1レイアウト
        case 333:
          return { actNums: [[2]], containerClass: "", innerClasses: [["card-col2s"]] };
        case 334:
          return { actNums: [[2]], containerClass: "", innerClasses: [["card-col2p"]] };

        // 3*1レイアウト
        case 49:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3s"]] };
        case 301:
          return { actNums: [[3]], containerClass: "", innerClasses: [["card-col3p"]] };
        case 372:
          return { actNums: [[2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"]] };
        case 335:
          return { actNums: [[1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"]] };

        // 4*1レイアウト
        case 374:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4s"]] };
        case 375:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
          }
          return { actNums: [[2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"]] };
        case 380:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
          }
          return { actNums: [[1, 3]], containerClass: "", innerClasses: [["card-col1s", "card-col3p"]] };
        case 376:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };
          }
          return { actNums: [[2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"]] };
        case 386:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col4p"]] };

        // 2*2レイアウト
        case 48:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s full"], ["card-col2s full"]] };
        case 304:
          return { actNums: [[4]], containerClass: "", innerClasses: [["card-col2p2r"]] };
        case 302:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2s"]] };
        case 303:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p"]] };
        case 10:
          return { actNums: [[2], [2]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2p"]] };

        // pronunciation-1,3レイアウト
        case 381:
          return { actNums: [[1], [3]], containerClass: "", innerClasses: [["card-col1s"], ["card-col3p"]] };

        // 1,2*2レイアウト
        case 377:
          if (this.isEnvironmentPc()) {
            return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[1, 4]], containerClass: "", innerClasses: [["card-col1s", "card-col4s"]] };
        case 309:
          if (this.isEnvironmentPc()) {
            return { actNums: [[1, 4]], containerClass: "", innerClasses: [["grid-left", "grid-right"]] };
          }
          return { actNums: [[1, 4]], containerClass: "", innerClasses: [["card-col1s", "card-col4p"]] };

        // 3,2レイアウト
        case 69:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2s"]] };
        case 308:
          return { actNums: [[5]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 332:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 1], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2s"]] };
        case 331:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
          }
          return { actNums: [[1, 2], [2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2s"]] };
        case 305:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p"]] };
        case 306:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2s"]] };
        case 307:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p"]] };
          }
          return { actNums: [[1, 3, 1]], containerClass: "", innerClasses: [["card-col1s", "card-col3p", "card-col1s"]] };
        case 310:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 1], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2p"]] };
        case 336:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };
          }
          return { actNums: [[1, 2], [2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2p"]] };
        case 47:
          return { actNums: [[3], [2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p"]] };

        // 2,3レイアウト
        case 337:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3s"]] };
        case 338:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
          }
          return { actNums: [[2], [2, 1]], containerClass: "", innerClasses: [["card-col2p"], ["card-col2p", "card-col1s"]] };
        case 371:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2p"], ["card-col3p"]] };
        case 382:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3p"]] };
        case 390:
          return { actNums: [[2], [3]], containerClass: "", innerClasses: [["card-col2s"], ["card-col3s"]] };
        case 391:
          return { actNums: [[2], [2, 1]], containerClass: "", innerClasses: [["card-col2s"], ["card-col2p", "card-col1s"]] };

        // 3*3レイアウト
        case 59:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3s"]] };
        case 65:
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col3p2r"]] };
        case 313:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 1], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col3s"]] };
        case 312:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3s"]] };
          }
          return { actNums: [[1, 2], [3]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col3s"]] };
        case 314:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
          }
          return { actNums: [[3], [2, 1]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p", "card-col1s"]] };
        case 369:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
          }
          return { actNums: [[3], [1, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col1s", "card-col2p"]] };
        case 339:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3s"], ["card-col3p"]] };
        case 319:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 1], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col2p", "card-col1s"]] };
        case 317:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 1], [1, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col1s", "card-col2p"]] };
        case 379:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 1], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col1s"], ["card-col3p"]] };
        case 373:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [2, 1]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col2p", "card-col1s"]] };
        case 318:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };
          }
          return { actNums: [[1, 2], [1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p"], ["card-col1s", "card-col2p"]] };
        case 11:
          return { actNums: [[3], [3]], containerClass: "", innerClasses: [["card-col3p"], ["card-col3p"]] };

        // 4,2レイアウト
        case 311:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2s"]] };
        case 316:
          return { actNums: [[6]], containerClass: "", innerClasses: [["card-col6p"]] };
        case 340:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2s"]] };
        case 367:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[1, 2, 1], [2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p", "card-col1s"], ["card-col2s"]] };
        case 315:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p"]] };
        case 320:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2s"]] };
        case 370:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p"]] };
        case 368:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p"]] };
        case 341:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
        case 22:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p"]] };
          }
          return { actNums: [[2, 2], [2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p"]] };
        case 384:
          return { actNums: [[4], [2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2s"]] };

        // 2,4レイアウト
        case 342:
          return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2s"], ["card-col4s"]] };
        case 378:
          if (this.isEnvironmentPc()) {
            return { actNums: [[2], [4]], containerClass: "", innerClasses: [["card-col2p"], ["card-col4p"]] };
          }
          return { actNums: [[2], [2, 2]], containerClass: "", innerClasses: [["card-col2p full"], ["card-col2p", "card-col2p"]] };

        // 4,3レイアウト
        case 321:
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3s"]] };
        case 322:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col3s"]] };
        case 343:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col3s"]] };
        case 344:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
          }
          return { actNums: [[4], [2, 1]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p", "card-col1s"]] };
        case 345:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
          }
          return { actNums: [[4], [1, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col1s", "card-col2p"]] };
        case 346:
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4s"], ["card-col3p"]] };
        case 347:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3s"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col3s"]] };
        case 348:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col1s"]] };
        case 349:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [2, 1]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p", "card-col1s"]] };
        case 366:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [1, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col1s", "card-col2p"]] };
        case 350:
          return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
        case 323:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [2, 1]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col1s"]] };
        case 351:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [3]], containerClass: "", innerClasses: [["card-col4p"], ["card-col3p"]] };
          }
          return { actNums: [[2, 2], [3]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col3p"]] };
        case 385:
          return { actNums: [[7]], containerClass: "", innerClasses: [["card-col7p"]] };

        // 3,4レイアウト
        case 352:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3s"], ["card-col4p"]] };
          }
          return { actNums: [[3], [2, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p", "card-col2s"]] };
        case 353:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3s"], ["card-col4p"]] };
          }
          return { actNums: [[3], [2, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2p", "card-col2p"]] };
        case 354:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3p"], ["card-col4p"]] };
          }
          return { actNums: [[3], [2, 2]], containerClass: "", innerClasses: [["card-col3p"], ["card-col2p", "card-col2s"]] };
        case 383:
          if (this.isEnvironmentPc()) {
            return { actNums: [[3], [4]], containerClass: "", innerClasses: [["card-col3s"], ["card-col4p"]] };
          }
          return { actNums: [[3], [2, 2]], containerClass: "", innerClasses: [["card-col3s"], ["card-col2s", "card-col2p"]] };

        // 4*2レイアウト
        case 324:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4s"]] };
        case 328:
          return { actNums: [[8]], containerClass: "", innerClasses: [["card-col8p"]] };
        case 355:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col4s"]] };
        case 356:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col4s"]] };
        case 326:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2s", "card-col2p"]] };
        case 327:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4s"]] };
          }
          return { actNums: [[1, 2, 2], [1, 2]], containerClass: "", innerClasses: [["card-col1s", "card-col2p", "card-col2s"], ["card-col1s", "card-col2s"]] };
        case 325:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4s"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col4s"]] };
        case 357:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col2s"]] };
        case 358:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2s", "card-col2p"]] };
        case 359:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p", "card-col2s"]] };
        case 360:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2s", "card-col2p"]] };
        case 361:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4s"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4s"], ["card-col2p", "card-col2p"]] };
        case 329:
          return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
        case 362:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2s"]] };
        case 363:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2s", "card-col2p"]] };
        case 364:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2s"], ["card-col2p", "card-col2p"]] };
        case 365:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col2p", "card-col2p"]] };
        case 330:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [2, 2]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col2p", "card-col2p"]] };
        case 387:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[4], [2, 2]], containerClass: "", innerClasses: [["card-col4p"], ["card-col2p", "card-col2p"]] };
        case 388:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2p", "card-col2p"], ["card-col4p"]] };
        case 389:
          if (this.isEnvironmentPc()) {
            return { actNums: [[4], [4]], containerClass: "", innerClasses: [["card-col4p"], ["card-col4p"]] };
          }
          return { actNums: [[2, 2], [4]], containerClass: "", innerClasses: [["card-col2s", "card-col2p"], ["card-col4p"]] };

        default:
          break;

          return null;
      }
    },
    /**
     * 特殊レイアウト用にpathstep.acts順序を変更して返却する
     */
    getLayoutPathstep: function(pathstep) {
      var result = pathstep;

      if (!this.isEnvironmentPc()) {
        var sortList = [];
        switch (pathstep.layoutID) {
          case 122:
            sortList = SORT_LAYOUT_122;
            break;
          case 307:
            sortList = SORT_LAYOUT_307;
            break;
          case 327:
            sortList = SORT_LAYOUT_327;
            break;
          default:
            break;
        }
        if (sortList.length != 0) {
          var acts = [];
          for (var i = 0; i < sortList.length; i++) {
            acts.push(pathstep.acts[sortList[i]]);
          }
          result = JSON.parse(JSON.stringify(pathstep));
          result.acts = acts;
        }
      }

      return result;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/commonLayout.js